<template>
  <div>
    <settings-control
        v-if="avResources"
        :modal-id="settingsControlModalId"
      :profile="profile"
      :session="session"
      :av-resources="avResources"
        :controls-font-scale="controlsFontScale"
    />
    <b-iconstack id="p-audio" :font-scale="controlsFontScale"
                 style="cursor:pointer; margin: 5px"
                 @click="handleToggle('audio')">
      <b-icon stacked icon="circle-fill"
              :variant="isSessionAvail ? `dark`: `default`"/>
      <b-icon stacked icon="mic-fill"
              variant="light"
              scale="0.5"
              shift-v="-0.25"
      />
      <b-icon v-if="isSessionAvail && toggle && !toggle.audio "
              stacked icon="slash-circle"
              variant="danger"
      />
    </b-iconstack>


    <b-iconstack id="p-video" :font-scale="controlsFontScale"
                 style="cursor:pointer; margin: 5px;"
                 @click="handleToggle('video')">
      <b-icon stacked icon="circle-fill"
              variant="dark"/>
      <b-icon stacked icon="camera-video"
              variant="light"
              scale="0.5"
              shift-v="-0.25"
      />
      <b-icon v-if="false" stacked icon="slash-circle" variant="danger"></b-icon>
    </b-iconstack>
    <b-iconstack id="p-layout" :font-scale="controlsFontScale"
                 style="cursor:pointer; margin: 5px"
                 @click="handleToggle('layout')">
      <b-icon stacked icon="circle-fill"
              variant="dark"/>
      <b-icon stacked icon="layout-wtf"
              variant="light"
              scale="0.5"
              shift-v="-0.25"
      />
      <b-icon v-if="false" stacked icon="slash-circle" variant="danger"></b-icon>
    </b-iconstack>
    <b-iconstack id="p-screenshare"  :font-scale="controlsFontScale"
                 style="cursor:pointer; margin: 5px"
                 @click="handleToggle('screenshare')">
      <b-icon stacked icon="circle-fill"
              variant="dark"/>
      <b-icon stacked icon="arrow-up-square"
              variant="light"
              scale="0.5"
              shift-v="-0.25"
      />
      <b-icon v-if="false" stacked icon="slash-circle" variant="danger"></b-icon>
    </b-iconstack>
    <b-iconstack id="p-emoji" :font-scale="controlsFontScale"
                 style="cursor:pointer; margin: 5px"
                 @click="handleToggle('emoji')">
      <b-icon stacked icon="circle-fill"
              variant="dark"/>
      <b-icon stacked icon="emoji-heart-eyes"
              variant="light"
              scale="0.5"
              shift-v="-0.25"
      />
      <b-icon v-if="false" stacked icon="slash-circle" variant="danger"></b-icon>
    </b-iconstack>
    <b-iconstack id="p-hand" :font-scale="controlsFontScale"
                 style="cursor:pointer; margin: 5px"
                 @click="handleToggle('hand')">
      <b-icon stacked icon="circle-fill"
              variant="dark"/>
      <b-icon stacked icon="hand-index"
              variant="light"
              scale="0.5"
              shift-v="-0.25"
      />
      <b-icon v-if="false" stacked icon="slash-circle" variant="danger"></b-icon>
    </b-iconstack>
    <b-iconstack id="p-exit" :font-scale="controlsFontScale"
                 style="cursor:pointer; margin: 5px"
                 @click="handleLeaveRoom">
      <b-icon stacked icon="circle-fill"
              variant="danger"/>
      <b-icon stacked icon="x-lg"
              variant="light"
              scale="0.5"
              shift-v="-0.25"
      />
      <b-icon v-if="false" stacked icon="slash-circle" variant="danger"></b-icon>
    </b-iconstack>
  </div>
</template>

<script>
import SettingsControl from "../settingsControl";
export default {
  name: "Sessions_Stage_Controls",
  components: {
    SettingsControl
  },
  props: {
    session: {
      type: Object,
      default: () => {}
    },
    profile: {
      type: Object,
      default: () => {}
    },
    isAvAvail: {
      type: Boolean,
      default: false
    },
    isSessionAvail: {
      type: Boolean,
      default: false
    },
    toggle: {
      type: Object,
      default: () => {}
    },
    avResources: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {},
  computed: {},
  methods: {
    /** CONTROLS **/
    handleToggle(toggleItem){
      this.$emit("button-toggle", toggleItem )
    },
    handleLeaveRoom() {
      this.$emit("leave-room-click");
    },
  },
  data() {
    return {
      controlsFontScale: 5,
      settingsControlModalId: "settings-modal-id"
    };
  }
};
</script>

<style lang="scss" scoped>
</style>
